import React from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'

const SupportMessage = () => {
  return (
    <MasterLayout>
        
    </MasterLayout>
  )
}

export default SupportMessage